<div class="formulario-persona" style="padding: 10px" *ngIf="habilitado">
  <!-- Para quien es la consulta -->
  <!-- <app-grupo-radiobutton descripcion_etiqueta="¿Para quién es la consulta?:" [(opciones)]="opcionesParaQuienEs"
        [(ngModel)]="paraQuienEs" (ngModelChange)="actualizarParaQuienEs()"
        valor_defecto="parami"></app-grupo-radiobutton> -->

  <app-titulo-h1
    *ngIf="etiqueta_consulta"
    [titulo]="etiqueta_consulta"
  ></app-titulo-h1>

  <!-- Nombre -->
  <app-campo-default
    id="nombre"
    descripcion_etiqueta="Nombre"
    placeholder_input="Ingresa tu nombre y apellido"
    [(ngModel)]="nombre"
    mensaje_error="{{ nombre_error_mensaje }}"
    [disabled]="!esAnonimo"
  ></app-campo-default>

  <!-- Apellido -->
  <!-- <app-campo-default id="apellido" descripcion_etiqueta="Apellido:" placeholder_input="Ingresa el primer apellido"
        mensaje_error="{{apellido_error_mensaje}}" [(ngModel)]="apellido"></app-campo-default>
    <app-error-seguimiento *ngIf="errorTrackingService.esErrorActual('apellido')"></app-error-seguimiento> -->

  <!-- Tipo documento -->
  <app-combo-default
    *ngIf="esAnonimo"
    descripcion_etiqueta="Tipo de documento"
    [(mensaje_error)]="tipo_documento_error_mensaje"
    (modelValueChange)="actualizarTipoDocumento($event)"
    [(ngModel)]="tipoDocumento"
    [(opciones)]="opcionesTipoDocumento"
  ></app-combo-default>
  <!-- Documento -->
  <app-campo-default
    *ngIf="esAnonimo"
    id="documento"
    descripcion_etiqueta="Número de documento"
    placeholder_input="Ingresa el documento"
    [(mensaje_error)]="documento_error_mensaje"
    [(ngModel)]="documento"
    (ngModelChange)="validarDocumento()"
  ></app-campo-default>

  <!-- Mail destino -->
  <app-campo-default
    descripcion_etiqueta="Correo electrónico"
    placeholder_input="ejemplo@mail.com.uy"
    mensaje_error="{{ correo_error_mensaje }}"
    [(ngModel)]="correo"
    (modelValueChange)="realizarValidaciones()"
    [disabled]="!esAnonimo"
  ></app-campo-default>

  <div style="padding-bottom: 5px">
    <label *ngIf="!esAnonimo"
      >Recuerde mantener sus datos personales y contacto actualizado. Las
      comunicaciones se harán por nuestras vias.
    </label>
    <a
      *ngIf="ctx?.modificarDatosUrl && !esAnonimo"
      [attr.href]="ctx.modificarDatosUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      Modificar mis datos
    </a>
  </div>

  <app-campo-texto
    id="consulta"
    placeholder_input="Escribí tu consulta."
    [(ngModel)]="consulta"
    [attachment]="true"
    etiqueta="Consulta"
    (obtener_attachments)="actualizarAdjuntos($event)"
    mensaje_error="{{ consulta_error_mensaje }}"
    [caracteres_maximo]="caracteres_maximo_consulta"
  ></app-campo-texto>

  <app-adjuntar-archivo
    etiqueta="Adjuntar archivos"
    (obtener_attachments)="actualizarAdjuntos($event)"
  ></app-adjuntar-archivo>

  <!-- Correos actualues -->
  <!-- <app-combo-especial-correo *ngIf="esParaMi" (nuevoEmail)="nuevoEmail($event)" (eliminarMail)="eliminarMail($event)"
        [(correos)]="correos"></app-combo-especial-correo> -->

  <!-- Alerta de errores -->

  <app-alerta-error
    id="existe-error"
    *ngIf="errores.length > 0"
    [errores]="errores"
  ></app-alerta-error>

  <app-alerta-error
    *ngIf="errorValidacion"
    id="existe-error-recaptcha"
    mensaje_unico="{{ mensajeError }}"
  ></app-alerta-error>

  <div id="captchaDiv2">
    <div id="recaptcha-container-hidden"></div>
  </div>
  <div
    id="captchaDiv"
    style="display: flex; justify-content: flex-end; padding-bottom: 5px"
  >
    <div id="recaptcha-container"></div>
  </div>
  <div class="acciones-formulario">
    <app-boton-primario-consulta
      boton_texto="Enviar consulta"
      (boton_funcion)="realizarConsulta()"
    >
    </app-boton-primario-consulta>

    <div class="spinner-center" style="padding-bottom: 5px; padding-top: 5px">
      <app-boton-secundario-consulta
        *ngIf="fromMenu"
        boton_texto="Volver al inicio"
        (boton_funcion)="switchAssistantHandler()"
      ></app-boton-secundario-consulta>
    </div>
  </div>
</div>

<div class="spinner-overlay" *ngIf="cargandoDatos">
  <div class="spinner-center">
    <mat-spinner diameter="80" color="primary"></mat-spinner>
    <label class="input-label" *ngIf="cargandoDatos">
      &nbsp;Cargando datos...
    </label>
  </div>
</div>

<div class="spinner-overlay" *ngIf="onSubmitProcess">
  <div class="spinner-center">
    <mat-spinner diameter="80" color="primary"></mat-spinner>
    <label class="input-label"> &nbsp;Enviando consulta... </label>
  </div>
</div>

<div
  class="spinner-overlay"
  *ngIf="!cargandoDatos && !habilitado"
  style="padding: 10px"
>
  <div class="card-body-content" *ngIf="!habilitado && !onError">
    <h4 class="titulo-principal mt-2 mb-4 f-22">
      No es posible visualizar el contenido del presente formulario ya que se
      encuentra deshabilitado.
    </h4>
    <br />
  </div>

  <div class="card-body-content" *ngIf="onError">
    <h4 class="titulo-principal mt-2 mb-4 f-22">
      En este momento no podemos atenderlo debido a que estamos experimentando
      algunos problemas técnicos; por favor intente comunicarse con nosotros más
      tarde.
    </h4>
    <br />
  </div>
</div>
